import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: '90%'
    },
    button: {
      marginRight: theme.spacing(1)
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    connectorActive: {
      '& $connectorLine': {
        borderColor: theme.palette.secondary.main
      }
    },
    connectorCompleted: {
      '& $connectorLine': {
        borderColor: theme.palette.primary.main
      }
    },
    connectorDisabled: {
      '& $connectorLine': {
        borderColor: theme.palette.grey[100]
      }
    },
    connectorLine: {
      transition: theme.transitions.create('border-color')
    }
  };
}); // function getSteps() {
// 	return [ 'Select campaign settings', 'Create an ad group', 'Create an ad' ];
// }
// function getStepContent(step) {
// 	switch (step) {
// 		case 0:
// 			return 'Select campaign settings...';
// 		case 1:
// 			return 'What is an ad group anyways?';
// 		case 2:
// 			return 'This is the bit I really care about!';
// 		default:
// 			return 'Unknown step';
// 	}
// }

var SMStepper = function SMStepper(props) {
  var classes = useStyles(); // const [ activeStep, setActiveStep ] = React.useState(0);
  // const steps = getSteps();
  // function handleNext() {
  // 	setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // }
  // function handleBack() {
  // 	setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // }
  // function handleReset() {
  // 	setActiveStep(0);
  // }

  var activeStep = props.activeStep,
      steps = props.steps,
      orientation = props.orientation,
      nonLinear = props.nonLinear;
  var connector = /*#__PURE__*/React.createElement(StepConnector, {
    classes: {
      active: classes.connectorActive,
      completed: classes.connectorCompleted,
      disabled: classes.connectorDisabled,
      line: classes.connectorLine
    }
  });
  return /*#__PURE__*/React.createElement(Stepper, {
    orientation: orientation,
    nonLinear: nonLinear,
    activeStep: activeStep,
    connector: connector
  }, steps.map(function (label) {
    return /*#__PURE__*/React.createElement(Step, {
      key: label
    }, /*#__PURE__*/React.createElement(StepLabel, null, label));
  }));
};

export { SMStepper };